export enum LinksEnum {
  HELP = 'https://ajuda.sei-calculos.com.br/',
  CHAT = 'https://sei.bitrix24.com/online/chatseicalculos/',
}
